/****   http.js   ****/
// 导入封装好的axios实例
import request from './request'
import qs from 'qs'
const http ={
    /**
     * methods: 请求
     * @param url 请求地址
     * @param params 请求参数
     */
    get(url,params,type,show){
        const config = {
            method: 'GET',
            url:url,
            show:show
        }
        if(params) config.params = params;

        return request(config)
    },
    post(url,params,type,show){
		console.log('type',type)
        const config = {
            method: 'POST',
            url:url,
			show:type
        }
		// config.headers = {
		//   'Content-Type': 'application/json'
		// }
        if(type){
          // console.log('dsds',params)
		  // config.headers = {
		  //   'Content-Type': 'application/json'
		  // }
            if(params) config.data = params
            // config.headers =  {
            //     'Content-Type': 'application/json;charset=UTF-8'
            // }
			// config.headers = {
			//   'Content-Type': 'application/json'
			// }
        }else{
            if(params) config.data = qs.stringify(params)
        }
        if(show==2){
          config.show = show
        }
        return request(config)
    },
    put(url,params){
        const config = {
            method: 'PUT',
            url:url
        }
        if(params) config.params = JSON.stringify(params)
        return request(config)
    },
    delete(url,params){
        const config = {
            methods: 'DELETE',
            url:url
        }
        if(params) config.params = params
        return request(config)
    }
}
//导出
export default http
